import {get} from 'lodash';

export default (state = {}, {coachId, performance}: any) => {
  return {
    ...state,
    allPerformances: {
      ...get(state, 'allPerformances', {}),
      [coachId]: performance,
    },
  };
};
